// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"_6vPnz","miniPDPWrapper":"hKolv"};